'use client';

import { c as _c } from "react/compiler-runtime";
import { PaginationSkeleton } from '@morpho-org/ui-v6/client';
import { Skeleton } from '@morpho-org/ui-v6/server';
import { type CSSProperties, memo } from 'react';
import { VaultTransactionsLayout } from '@/components/VaultPage/components/VaultTransactionsLayout';
import { useIsBelowBreakpoint } from '@/hooks/useBreakpoints';
export interface VaultYourTransactionsLoadingProps {
  tableHeight?: CSSProperties['height'];
}
const VaultYourTransactionsLoading = t0 => {
  const $ = _c(10);
  const {
    tableHeight: t1
  } = t0;
  const tableHeight = t1 === undefined ? "338px" : t1;
  const isMediumScreen = useIsBelowBreakpoint("m");
  let t2;
  if ($[0] !== isMediumScreen) {
    t2 = <>{isMediumScreen ? <div className="gap-xs flex w-[100%] flex-col"><Skeleton className="h-[24px] w-[127px] rounded-[20px]" /><Skeleton className="h-[24px] w-[127px] rounded-[20px] max-sm:w-full" /></div> : <Skeleton className="h-[24px] w-[127px] rounded-[20px]" />}</>;
    $[0] = isMediumScreen;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== tableHeight) {
    t3 = <Skeleton className="w-[100%] rounded-[20px]" style={{
      height: tableHeight
    }} />;
    $[2] = tableHeight;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <PaginationSkeleton />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t3) {
    t5 = <div className="gap-xs flex flex-col">{t3}{t4}</div>;
    $[5] = t3;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t2 || $[8] !== t5) {
    t6 = <VaultTransactionsLayout title="Your transactions" tableSettingsSlot={t2}>{t5}</VaultTransactionsLayout>;
    $[7] = t2;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
};
export default memo(VaultYourTransactionsLoading);